<template>
    <b-container fluid class="p-0">
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">Detalhes da Perda de Qualificação OSCIP</span>
                    <btn-voltar />
                </h6>
            </template>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>CNPJ</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.NrCnpj }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Nome da Entidade</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.NmEntidade }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Endereço</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.DeEndereco }}</span>
                </b-col>
            </b-row>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Cidade</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.NmCidade }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>UF</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.NmUf }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>CEP</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.NmCep }}</span>
                </b-col>
            </b-row>
            <b-row class="m-2">
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Data da Publicação no DOU</b></span>
                    <br />
                    <span class="pos-left">{{ formatData(oscip.DtPublicacaoDou) }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Tipo do Documento</b></span>
                    <br />
                    <span class="pos-left">{{ oscip.DeTipoDocumento }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Arquivo (PDF)</b></span><br>
                    <span class="pos-left">{{ oscip.nmArquivo }}</span>
                    <div class="wrapper-icon">
                        <btn-download :fazerDownload="baixarAnexoOscip" :texto="''" />
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </b-container>    
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import oscipService from "@/services/contratacao/oscipService"
import { Oscip } from "@/types/contratacao/oscip";

const CompProps = Vue.extend({
  name: "DetalhesPerdaDeQualificacaoOscip",
  components: { 
    BtnVoltar, BtnDownload
  },
  props: {
    idPerdaQualificacao: {
        type: String,
        required: true
    }
  }
});

@Component
export default class DetalhesPerdaDeQualificacaoOscip extends mixins(UtilsTS, CompProps) {
    oscip = new Oscip();
    screenBlocked = false;

    async created() {
        try {
            this.screenBlocked = true
            if (this.idPerdaQualificacao.length > 0) {
                //debug: await new Promise(r => setTimeout(r, 2000));  // js async sleep
                this.oscip = await oscipService.getPerdaOscipId(this.idPerdaQualificacao);
            }
        }
        catch (e: any) {
            console.error('Erro ao receber dados da perda de qualificação', e)
        } 
        finally {
            this.screenBlocked = false
        }
    }

    async baixarAnexoOscip() {
        const response = await oscipService.baixarAnexoOscip(this.idPerdaQualificacao);
        this.download(this.oscip.nmArquivo, response.data)
    }

}
</script>

<style></style>